/**
 * Image class
 * @private
 */
/* eslint-disable */
var Image = /** @class */ (function () {
    function Image() {
    }
    return Image;
}());
export { Image };
